export default "<img [src]=\"imageSrc\" default=\"{{defaultPicture}}\" [alt]=\"imageAlt\" />\n"